import useApiClient from './api-client'
import { getDeviceId } from '@/utils/common'
import type { AuthUserLogin, FzendeskTokenResp } from '@/types/api'

const _getDefaultPayload = () => {
  const { userAgent } = useDevice()
  return {
    os: 'web',
    osVersion: userAgent,
    appVersion: '1.0',
    deviceId: getDeviceId(),
  }
}

export async function login({ email, password, verification_token }: { email: string; password: string; verification_token: string }) {
  const api = useApiClient<AuthUserLogin>()
  const payload = {
    ..._getDefaultPayload(),
    username: email,
    password,
    verification_token,
  }
  const res = await api('/login', {
    method: 'POST',
    body: payload,
  })

  return res
}
type UserContract = {
  isTermsAccepted: boolean
  isMarketingAllowed: boolean
}

export type FacebookRegisterParams = {
  userContract: UserContract
}

export type GoogleRegisterParams = {
  userContract: UserContract
}

export async function register({
  email,
  password,
  verification_token,
  isTermsAccepted,
  isMarketingAllowed,
}: {
  email: string
  password: string
  verification_token: string
  isTermsAccepted?: boolean
  isMarketingAllowed?: boolean
}) {
  const api = useApiClient()

  const registerData = {
    ..._getDefaultPayload(),
    username: email,
    password,
    verification_token,
    userContract: {
      isTermsAccepted,
      isMarketingAllowed,
    },
  }
  const res = await api('/register', {
    method: 'POST',
    body: registerData,
  })

  return res
}

export async function logout() {
  const api = useApiClient()
  const res = await api('/logout', {
    method: 'POST',
  })

  return res
}

export async function forgotPassword({ email, verification_token }: { email: string; verification_token: string }) {
  const api = useApiClient()
  // TODO: 等後端開正確的 api
  const forgotPasswordData = {
    ..._getDefaultPayload(),
    email,
    verification_token,
  }
  const res = await api('/password/recover', {
    method: 'POST',
    body: forgotPasswordData,
  })

  return res
}

export async function resetPassword({ password, token }: { password: string; token: string }) {
  const api = useApiClient()
  const forgotPasswordData = {
    password,
    token,
  }
  const res = await api('/password/reset', {
    method: 'POST',
    body: forgotPasswordData,
  })

  return res
}

export async function changePassword({ oldPassword, newPassword }: { oldPassword: string; newPassword: string }) {
  const api = useApiClient()
  const changePasswordData = {
    old_pwd: oldPassword,
    new_pwd: newPassword,
  }
  const res = await api('/password/change', {
    method: 'POST',
    body: changePasswordData,
  })

  return res
}

export async function facebookLogin(fbToken: string) {
  const api = useApiClient()
  const payload = {
    ..._getDefaultPayload(),
    fbToken,
  }
  const res = await api('/login/facebook', {
    method: 'POST',
    body: payload,
  })

  return res
}

export async function facebookRegister(fbToken: string, param: FacebookRegisterParams) {
  const api = useApiClient()

  const registerData = {
    ..._getDefaultPayload(),
    fbToken,
    ...param,
  }

  const res = await api('/register/facebook', {
    method: 'POST',
    body: registerData,
  })

  return res
}

export async function googleLogin(googleToken: string) {
  const api = useApiClient()
  const payload = {
    ..._getDefaultPayload(),
    access_token: googleToken,
  }

  const res = await api('/login/google', {
    method: 'POST',
    body: payload,
  })

  return res
}

export async function googleRegister(googleToken: string, param: GoogleRegisterParams) {
  const api = useApiClient()

  const registerData = {
    ..._getDefaultPayload(),
    access_token: googleToken,
    ...param,
  }

  const res = await api('/register/google', {
    method: 'POST',
    body: registerData,
  })

  return res
}

export async function getZendeskJwt() {
  const api = useApiClient<FzendeskTokenResp>()
  const res = await api('/zendesk/token')

  return res
}
